export const generateIsoDateString = _date => {
  // return new Date(_date).toISOString().split('T')[0];
  const _dateObj = new Date(_date);
  const year = _dateObj.getFullYear();
  let month = `${_dateObj.getMonth() + 1}`;
  let dt = `${_dateObj.getDate()}`;
  if (parseInt(dt) < 10) {
    dt = `0${dt}`;
  }
  if (parseInt(month) < 10) {
    month = `0${month}`;
  }
  return `${year}-${month}-${dt}`;
};

export const getDisplayDate = dateIso => {
  return new Date(dateIso).toUTCString().split(' ').slice(0, -2).join(' ');
  // return format: 'Fri, 26 Jan 2024'
};

export const getTimezoneFormattedDateObj = _date => {
  // Not in use
  return new Date(_date.getTime() + _date.getTimezoneOffset() * 60 * 1000);
};
